// 前边带选择框的input框
<template>
	<el-input v-model="innnerValue" class="mutiple-input" size="small">
		<div slot="prepend" :style="prependStyle">
			<el-select v-model="select" @change="change" size="small">
				<el-option
					v-for="(item, index) in options"
					:key="index"
					:label="item.label"
					:value="item.prop"
				></el-option>
			</el-select>
		</div>
	</el-input>
</template>

<script>
export default {
	name: "mutiple-input",
	props: {
		value: "",
		options: {
			type: Array,
			default: function () {
				return [];
			},
			required: true,
		},
		prependStyle: {
			type: Object,
			default: function () {
				return {
					width: "100px",
				};
			},
		},
		inputStyle: {
			type: Object,
			default: function () {
				return {
					width: "220px",
				};
			},
		},
	},

	data() {
		return {
			select: this.options[0].prop,
		};
	},
	computed: {
		innnerValue: {
			set(val) {
				this.value[this.select] = val;
				this.$emit("input", this.value);
			},
			get() {
				return this.value[this.select];
			},
		},
		// select: {
		// 	get() {
		// 		if (!this._select) {
		// 			return this.options[0].prop;
		// 		} else {
		// 			return this._select;
		// 		}
		// 	},
		// 	set(val) {
		// 		this._select = val;
		// 	},
		// },
	},

	methods: {
		change(val) {
			this.options.forEach((item) => {
				if (item.prop !== val) {
					console.log(item.prop);
					this.value[item.prop] = "";
				}
			});

			this.select = val;

			this.$emit("condition", val);
		},
	},
};
</script>
<style lang='scss' scoped>
::v-deep.mutiple-input {
	.el-input-group__prepend {
		min-width: 110px;
		background-color: #fff;
		border-top-left-radius: 20px;
		border-bottom-left-radius: 20px;
		padding: 0 0px 0 0px;
		.el-select {
			display: inline-block;
			width: 100%;
			margin: -10px 0px;
			.el-input {
				width: 100%;
				input {
					width: 100%;
				}
			}
			// .el-input__suffix{
			// 	height: none;
			// }
		}
	}

	.el-input__inner {
		width: 220px;
		border-top-right-radius: 30px !important;
		border-bottom-right-radius: 30px !important;

		border-top-left-radius: 0 !important;
		border-bottom-left-radius: 0 !important;
	}
}
</style>